var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBtnFolder = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 28,
  height: 28,
  fill: "none"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 28,
  height: 28,
  fill: "#F6F6F6",
  rx: 6
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#777",
  strokeLinecap: "square",
  strokeWidth: 1.1,
  d: "M8 9.616v9.691h12V10.5h-6.462l-.623-1.807s-.375-.006-.586 0H8.001z"
})));
export default SvgBtnFolder;